import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';

// The blocking overlay the Angular save panel showed while a save was in flight. A course save can
// take a while, so the admin needs to see that something is happening and that the form is locked.
export default function SavingOverlay({ open }: { open: boolean }) {
    return (
        <Dialog open={open} maxWidth="xs">
            <DialogTitle>Saving</DialogTitle>
            <DialogContent>
                <Typography>Please wait...</Typography>
            </DialogContent>
        </Dialog>
    );
}
